// Third-party
import React from 'react';

// Components
import AddEnterpriseMemberForm from '../forms/AddEnterpriseMemberForm';
import EnterpriseMember from '@/types/enterprise-member';
import Modal from '@/views/components/modals/AccessibleModal';

type Props = {
  show: boolean;
  onCancel: () => void;
  onSave: (fname: string, lname: string, email: string, uid?: string, nameId?: string) => Promise<EnterpriseMember>;
  useMemberUID: boolean;
  useMemberNameID: boolean;
};

const AddEnterpriseMemberModal = (props: Props) => (
  <Modal show={props.show} className="add-enterprise-member-modal" onHide={props.onCancel} dialogClassName="modal-dialog-centered">
    <AddEnterpriseMemberForm
      onAddMember={props.onSave}
      onCancel={props.onCancel}
      titleTextKey="Admin.Enterprise.AddMember"
      addButtonTextKey="Admin.Enterprise.AddMemberBtn"
      infoTextKey="Admin.Enterprise.AddMemberInfo"
      successTextKey="Admin.Enterprise.AddMemberSuccess"
      useMemberUID={props.useMemberUID}
      useMemberNameID={props.useMemberNameID}
    />
  </Modal>
);

export default AddEnterpriseMemberModal;
